import { render, staticRenderFns } from "./ShopMallPostSaleSucc.vue?vue&type=template&id=08d5ae2e&scoped=true&"
import script from "./ShopMallPostSaleSucc.vue?vue&type=script&lang=js&"
export * from "./ShopMallPostSaleSucc.vue?vue&type=script&lang=js&"
import style0 from "./ShopMallPostSaleSucc.vue?vue&type=style&index=0&id=08d5ae2e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d5ae2e",
  null
  
)

export default component.exports